export default __webpack_public_path__ + "static/media/Human8.d14d0a39.png";